import { useCobranzaImpersonation } from "@/contexts/CobranzaImpersonationContext";
import { VerComoPersonasSelector } from "@/components/admin/VerComoPersonasSelector";

/** Menú "Portal Cobranza" en `menus`: por id (igual en dev y prod), nunca por nombre. */
const PORTAL_COBRANZA_MENU_ID = 19;
const PORTAL_PRODUCTOS_MENU_ID = 36;

/** Rutas del portal para la lista del servidor (`get_ver_como_personas`). */
const RUTAS_POR_MENU: Record<number, string[]> = {
  [PORTAL_COBRANZA_MENU_ID]: ["/admin/portal-cobranza/%"],
  [PORTAL_PRODUCTOS_MENU_ID]: ["/admin/portal-productos/%"],
};

/**
 * "Ver como" de los portales Cobranza (menú 19) y Productos (menú 36), que comparten
 * `CobranzaImpersonationContext`. Por persona (regla de Eduardo, 2026-10-27): solo quien entra
 * a ese portal, en bloques por rol; el contexto guarda su rol de acceso para menús y perfil.
 */
export function CobranzaImpersonationSelector({ menuId = PORTAL_COBRANZA_MENU_ID }: { menuId?: number } = {}) {
  const { impersonatedEmail, impersonatedName, setImpersonated, clearImpersonation } = useCobranzaImpersonation();
  return (
    <VerComoPersonasSelector
      rutas={RUTAS_POR_MENU[menuId] ?? RUTAS_POR_MENU[PORTAL_COBRANZA_MENU_ID]}
      seleccionadoEmail={impersonatedEmail}
      seleccionadoNombre={impersonatedName}
      onElegir={(p) =>
        setImpersonated(p.email, p.nombre, p.personaId, p.rolAccesoId, p.authUserId, p.rolAccesoNombre)
      }
      onLimpiar={clearImpersonation}
    />
  );
}
